import React, { PropTypes } from 'react';
import { NitroIcon } from 'nitro-components';
import { MenuRow, MenuLink, MenuRowHeader } from './styles';

const RouteContent = ({ icon, active, title, width }) => (
  <MenuRow active={active}>
    <MenuRowHeader active={active} width={width}>
      {icon && <NitroIcon name={icon} variant="white" size={14} right={23} />}
      <span>{title}</span>
    </MenuRowHeader>
  </MenuRow>
);

/**
 * This component displays a menu link that will direct to another page represented as a
 * navigable row for the Menu Sidebar.
 */
const MenuRoute = ({ menu, active, handleRoute, width, onClose, isAction }) => {
  const to = menu.route || menu.url;
  const target = menu.route ? null : '_blank';
  if (isAction(menu)) {
    return (
      <div
        onClick={() => {
          handleRoute(menu);
          onClose();
        }}
      >
        <RouteContent
          icon={menu.icon}
          active={active}
          title={menu.title}
          width={width}
        />
      </div>
    );
  }
  return (
    <MenuLink to={to} target={target}>
      <RouteContent
        icon={menu.icon}
        active={active}
        title={menu.title}
        width={width}
      />
    </MenuLink>
  );
};

MenuRoute.propTypes = {
  // Details of the link to display and navigate to.
  menu: PropTypes.object.isRequired,

  // `true` if the menu route should be displayed as an actively selected menu item.
  active: PropTypes.bool,

  // An optional function to act as a callback for when the route is clicked
  handleRoute: PropTypes.func,

  // The width of the Accordion
  width: PropTypes.string.isRequired
};

MenuRoute.defaultProps = {
  active: false,
  handleRoute: undefined
};

export default MenuRoute;



// WEBPACK FOOTER //
// ./src/components/common/Menu/Sidebar/MenuRoute.js